module.exports = __webpack_public_path__ + "img/notArrivedCount.07f9d02e.svg";